import { getText,state } from './main';

import '../img/pc/vi/vi-fb-share.jpg'
import '../img/pc/th/th-fb-share.jpg'

const getLoginStatus = isClean => {
	return new Promise(resolve => {
		FB.getLoginStatus(response => {
			resolve(response.status === 'connected');
		}, isClean);
	});
};

const fbLogin = () => {
	return new Promise(resolve => {
		FB.login(function (response) {
			resolve(response.status === 'connected');
		});
	});
};

const getFbUserInfo = function () {
	return new Promise(resolve => {
		FB.api('/me', function (res) {
			resolve({ fb_id: res.id, fb_name: res.name });
		});
	});
};

const excShare = info => {
	return new Promise(resolve => {
		FB.ui(info, function (res) {
			resolve(res && !res.error_message);
		});
	});
};
export const fbShare = async () => {
	let sym = state.lang.includes("th") ? '37games':'slfuntap';
	const message = getText('fbmessage');
	const title = getText('fbtitle');
	let picUrl = state.lang.includes("th") ? `https://gevents.${sym}.com/dlssrvtline2/img/th-fb-share.jpg`:`https://gevents.${sym}.com/dlssrvtline2/img/vi-fb-share.jpg`;
	let shareUrl = `https://gevents.${sym}.com/dlssrvtline2/index.html?cid=share&scid=fb`;
	let info = {
		method: 'share',
		href: `https://gactivityapi.${sym}.com/fbShareCustomize/customizeShare/message/${message}/app_id/924584694817603/share_title/${title}/redict_url/${encodeURIComponent(
			shareUrl
		)}/pic_url/${encodeURIComponent(picUrl)}`,
		display: 'popup',
	};

	let checkRes = await getLoginStatus();
	!checkRes && (await fbLogin());
	await excShare(info);
};
